<template>
  <div class="pl-4 text-base font-medium text-gray-900 border-l-2 border-blue-700">
    <p>
      <slot />
    </p>
  </div>
</template>
